import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type {
  LegalEntityClient,
  LegalEntityHierarchyDto,
} from '@/api/legal-entity-client';
import { useLegalEntityClient } from '@/api/legal-entity-client-context';

// =============================================================================
// use-legal-entities.ts — Hook TanStack Query de la HIÉRARCHIE MULTI-ÉTABLISSEMENT (T7).
// =============================================================================
// LECTURE cross-fournisseur (withAdmin) : vue groupée des établissements d'un SIREN.
// ZÉRO règle métier ici : l'autorité (RLS, validation SIREN, 404) est l'API ; l'erreur
// remonte telle quelle (LegalEntityApiError porte le status). Gaté par `siren` (enabled).

/** Clé de query de la hiérarchie d'un SIREN. */
export const legalEntityHierarchyKey = (siren: string): readonly unknown[] => [
  'legal-entities',
  'hierarchy',
  siren,
];

/**
 * Vue groupée des établissements d'un SIREN (T7-MULTI-ETAB, lecture seule). Gaté par `siren`
 * (aucun appel si vide). L'écran mappe l'erreur via son `status` (400 SIREN invalide, 404 vide).
 */
export function useLegalEntityHierarchy(
  siren: string | undefined,
): UseQueryResult<LegalEntityHierarchyDto, Error> {
  const client: LegalEntityClient = useLegalEntityClient();
  return useQuery<LegalEntityHierarchyDto, Error>({
    queryKey: legalEntityHierarchyKey(siren ?? ''),
    queryFn: () => client.getHierarchy(siren as string),
    enabled: siren !== undefined && siren.length > 0,
  });
}
